import PropTypes from 'prop-types';
import React from 'react';
import {connect as connectR} from 'react-redux';
import {Link} from 'react-router';
import {Col, Row} from 'react-bootstrap';
import translate from './translate';
import TranslationUtil from '../util/translation';
import {setSettingsLanguage} from '../store/genericSettingsSlice';
import {SetPartnerManagerLanguage} from '../store/partnerManagerSlice';

const CL_LANGUAGE = 'language';
const CL_ACTIVE_LANGUAGE = 'language selected';

class Footer extends React.Component {
    static propTypes = {
        settingsLanguage: PropTypes.string.isRequired,
        loggedIn: PropTypes.bool.isRequired,
        setSettingsLanguage: PropTypes.func.isRequired,
        SetPartnerManagerLanguage: PropTypes.func.isRequired,
    };

    _handleGerman = (event) => {
        event.preventDefault();
        this._handleLanguage('ger');
    };

    _handleEnglish = (event) => {
        event.preventDefault();
        this._handleLanguage('eng');
    };

    _handleLanguage = (lng) => {
        if (this.props.loggedIn) {
            this.props.SetPartnerManagerLanguage(lng);
        }
        this.props.setSettingsLanguage(lng);
    };

    render() {
        const language = TranslationUtil.getCurrentLanguage(
            this.props.settingsLanguage
        );
        let date = new Date();
        date = date.getFullYear();

        return (
            <div className="footer-wrapper">
                <div className="footer">
                    <div className="container">
                        <Row>
                            <Col
                                xs={6}
                                sm={6}
                                md={6}
                                lg={6}
                                className="pull-right"
                            >
                                <div className="pull-right footer-links">
                                    {language && (
                                        <>
                                            {language === 'ger' ? (
                                                <>
                                                    <span className={CL_ACTIVE_LANGUAGE}>DE</span>
                                                    <Link
                                                        to="#EN"
                                                        className={CL_LANGUAGE}
                                                        onClick={this._handleEnglish}
                                                    >
                                                        EN
                                                    </Link>
                                                </>
                                            ) : (
                                                <>
                                                    <Link
                                                        to="#DE"
                                                        className={CL_LANGUAGE}
                                                        onClick={this._handleGerman}
                                                    >
                                                        DE
                                                    </Link>
                                                    <span className={CL_ACTIVE_LANGUAGE}>EN</span>
                                                </>
                                            )}
                                        </>
                                    )}
                                    <Link
                                        to={this.props.strings.imprintLink}
                                        target="_blank"
                                    >
                                        {this.props.strings.imprint}
                                    </Link>
                                    <Link
                                        to={
                                            this.props.strings.privacyPolicyLink
                                        }
                                        target="_blank"
                                    >
                                        {this.props.strings.data}
                                    </Link>
                                </div>
                            </Col>
                            <Col xs={6} sm={6} md={6} lg={6}>
                                <span className="footer-2-copy first">
                                    &copy; WeWash GmbH {date}
                                </span>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default connectR(
    (store) => ({
        loggedIn: store.auth.authentication.loggedIn,
        settingsLanguage: store.genericSettings.language,
    }),
    {setSettingsLanguage, SetPartnerManagerLanguage}
)(translate('Footer')(Footer));
